<template>
  <v-card
    elevation="2"
    class="pa-3"
  >
    <v-form
      v-model="valid"
      ref="form"
    >
      <input
        id="user-id"
        type="hidden"
        v-model="grupo.usuario"
      />
      <input
        id="grupo-id"
        type="hidden"
        v-model="grupo.id"
      />
      <input
        id="grupo-uuid"
        type="hidden"
        v-model="grupo.uuid"
      />
      <v-row>
        <v-col
          cols="12"
          md="2"
        >
          <v-text-field
            v-model="codigo"
            label="Código"
            outlined
            dense
          >
            <v-icon
              slot="append"
              color="success"
              large
              @click="loadDialog"
            >
              mdi-magnify
            </v-icon>
          </v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="3"
          v-if="codigo"
        >
          <v-checkbox
            v-model="grupo.inativar"
            label="Inativar menu ?"
            color="success"
            v-show="mode === 'save'"
          >
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-text-field
            v-model="grupo.nome"
            label="Nome do grupo"
            outlined
            required
            dense
            v-if="mode === 'save'"
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="2"
        >
          <v-text-field
            v-model="grupo.page_grupo"
            label="Página do grupo"
            outlined
            required
            dense
            v-if="mode === 'save'"
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="grupo.mdi_menu_grupo"
            label="Ícone para este grupo"
            outlined
            required
            dense
            v-if="mode === 'save'"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="9"
        >
          <v-textarea
            v-model="grupo.ds_grupo"
            label="Descrição"
            auto-grow
            outlined
            rows="3"
            row-height="25"
            dense
            v-if="mode === 'save'"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-card>
        <v-tabs
          v-model="tabs"
          height="45"
        >
          <v-tab>
            <v-icon class="mr-2">
              mdi-note-text
            </v-icon>
            Menus
          </v-tab>
        </v-tabs>
        <v-divider></v-divider>
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-card flat>
              <v-row justify="space-around">
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-card>
                    <v-card-title>
                      Menus do grupo
                    </v-card-title>
                    <v-data-table
                      :headers="headersMenus"
                      :items="menus"
                      :search="search"
                    >
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-icon
                          medium
                          color="primary"
                          class="mr-2"
                          @click="loadMenu(item)"
                        >
                          mdi-square-edit-outline
                        </v-icon>
                        <v-icon
                          medium
                          color="error"
                          class="mr-2"
                          @click="loadMenu(item, 'remove')"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-data-table>
                    <v-row>
                      <v-col
                        cols="12"
                        md="6"
                      >
                        <v-btn
                          color="success"
                          class="ml-4 mb-2"
                          v-if="codigo"
                          @click="loadAddMenu"
                        >
                          <v-icon left>
                            mdi-camera
                          </v-icon>
                          Adicionar menu
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
      <v-row class="mt-4">
        <v-col
          cols="12"
          md="10"
        >
          <v-btn
            :disabled="!valid"
            color="success"
            class="mr-4"
            v-if="mode === 'save'"
            @click="save"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>
            Salvar
          </v-btn>
          <v-btn
            color="error"
            class="mr-4"
            v-if="mode === 'remove'"
            @click="remove"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>
            Deletar
          </v-btn>
          <v-btn
            color="secondary"
            class="mr-4"
            @click="reset"
          >
            <v-icon left>
              mdi-broom
            </v-icon>
            Limpar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-row justify="space-around">
      <v-col cols="auto">
        <v-dialog
          v-model="dialog"
          transition="dialog-bottom-transition"
          fullscreen
        >
          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Pesquisar grupos
              </v-toolbar>
              <v-card-title>
                <v-text-field
                  class="search"
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                >
                </v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="grupos"
                :search="search"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    medium
                    color="primary"
                    class="mr-2"
                    @click="loadGrupo(item)"
                  >
                    mdi-square-edit-outline
                  </v-icon>
                  <v-icon
                    medium
                    color="error"
                    class="mr-2"
                    @click="loadGrupo(item, 'remove')"
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end">
                <v-btn
                  color="error"
                  @click="dialog.value = false"
                >Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-col>
    </v-row>
    <v-container>
      <v-dialog
        v-model="addMenu"
        transition="dialog-top-transition"
      >
        <template v-slot:default="dialog">
          <v-card>
            <v-toolbar
              color="primary"
              dark
            >
              Menu
            </v-toolbar>
            <v-card
              elevation="2"
              class="pa-3"
            >
              <div class="ma-5">
                <PageTitle
                  icon="mdi-pencil-box-outline"
                  sub="Menus do site"
                />
                <v-form>
                  <input
                    id="menu-id"
                    type="hidden"
                    v-model="menu.id"
                  />
                  <input
                    id="menu-uuid"
                    type="hidden"
                    v-model="menu.uuid"
                  />
                  <input
                    id="menu-user"
                    type="hidden"
                    v-model="menu.usuario"
                  />
                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field
                        v-model="codigo"
                        label="Código"
                        dense
                        filled
                      >
                      </v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                      v-if="codigo"
                    >
                      <v-checkbox
                        v-model="menu.inativar"
                        label="inativar menu?"
                        color="success"
                        class="mt-0 mb-2"
                        v-show="mode === 'save'"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-text-field
                        v-model="menu.nome"
                        label="Nome do menu"
                        outlined
                        required
                        dense
                        v-if="mode === 'save'"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <v-text-field
                        v-model="menu.path_name"
                        label="Página deste menu"
                        outlined
                        required
                        dense
                        v-if="mode === 'save'"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-text-field
                        v-model="menu.link"
                        label="Link"
                        outlined
                        required
                        dense
                        v-if="mode === 'save'"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="8"
                    >
                      <v-textarea
                        v-model="menu.descricao"
                        label="Descrição"
                        auto-grow
                        outlined
                        rows="3"
                        row-height="25"
                        dense
                        v-if="mode === 'save'"
                      >
                      </v-textarea>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
              <v-card-actions class="justify-end">
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="codigo"
                  type="submit"
                  @click="addSair"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar e sair
                </v-btn>
                <v-btn
                  color="success"
                  class="mr-4"
                  v-if="codigo"
                  type="submit"
                  @click="addCont"
                >
                  <v-icon left>
                    mdi-content-save
                  </v-icon>
                  Salvar e continuar
                </v-btn>
                <v-btn
                  color="error"
                  class="mr-4"
                  v-if="codigo"
                  @click="resetMenu"
                >
                  Limpar
                  <v-icon left>
                    mdi-broom
                  </v-icon>
                </v-btn>
                <v-btn
                  color="danger"
                  class="mr-4"
                  @click="dialog.value = false"
                >
                  Sair
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-card>
        </template>
      </v-dialog>
    </v-container>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
export default {
  name: 'GrupoMenuAdmin',
  computed: mapState(['user']),
  data: () => ({
    uuid: '',
    tabs: null,
    codigo: '',
    dialog: false,
    addMenu: false,
    tabela: 'grupoMenu',
    search: '',
    mode: 'save',
    grupo: {},
    grupos: [],
    menu: {},
    menus: [],
    length: '',
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Grupo', value: 'nome' },
      { text: 'Ícone', value: 'mdi_menu_grupo' },
      { text: 'Descrição', value: 'ds_grupo' },
      { text: 'Situação', value: 'inativar', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersMenus: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome do menu', value: 'nome' },
      { text: 'Caminho', value: 'url_int' },
      { text: 'Link externo', value: 'url_ext' },
      { text: 'Descriçao.', value: 'descricao' },
      {
        text: 'Situação',
        value: 'inativar',
        sortable: false,
        formatter: value => value ? 'Sim' : 'Não'
      },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    valid: false
  }),
  methods: {
    save () {
      const method = this.grupo.id ? 'put' : 'post'
      const id = this.grupo.id ? `/${this.grupo.id}` : ''
      axios[method](`${baseApiUrl}/grupo-de-menus-sys${id}`, this.grupo)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    saveCat () {
      const method = this.menu.id ? 'put' : 'post'
      const id = this.menu.id ? `/${this.menu.id}` : ''
      this.menu.groupId = this.grupo.id
      axios[method](`${baseApiUrl}/menu-sys${id}`, this.menu)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetMenu()
          this.loadMenus()
        })
        .catch(showError)
    },

    remove () {
      alert('Deseja realmente remover?')
    },
    loadGrupos () {
      const url = `${baseApiUrl}/grupo-de-menus-sys`
      axios.get(url).then(res => {
        this.grupos = res.data
      })
    },
    loadMenus () {
      const idC = this.grupo.id
      const url = `${baseApiUrl}/menus-do-grupo-admin/${idC}`
      axios.get(url).then(res => {
        this.menus = res.data
      })
    },
    loadGrupo (grupo, mode = 'save') {
      this.mode = mode
      this.grupo = { ...grupo }
      this.codigo = this.grupo.id
      this.dialog = false
      this.valid = true
      this.loadMenus()
    },
    reset () {
      this.mode = 'save'
      this.grupo = {}
      this.codigo = ''
      this.menus = []
      this.loadUser()
    },
    resetMenu () {
      this.menu = {}
      this.menu.usuario = this.user.id
      this.menu.uuid = uuid.v1()
    },
    loadDialog () {
      this.dialog = true
      this.loadGrupos()
    },
    loadAddMenu () {
      this.menu.uuid = uuid.v1()
      this.menu.usuario = this.user.id
      this.addMenu = true
    },
    addCont () {
      this.saveCat()
    },
    addSair () {
      this.saveCat()
      this.addMenu = false
    },
    loadUser () {
      this.grupo.uuid = uuid.v1()
      this.grupo.usuario = this.user.id
    }
  },
  mounted () {
    this.loadUser()
  }
}
</script>

<style scoped>
.container {
  width: 98% !important;
}
</style>
